module.exports = __webpack_public_path__ + "resources/a7a9ab2214a9aa96ac43326655fa9f0b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/backgroundsupermove3.png
// module id = 197
// module chunks = 0